import DPTextBox from "framework/components/DPTextBox"
import React from "react"
import MetaTags from "react-meta-tags"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
//Import DPComponents
import DPTopToolBar from "../../../framework/widgets/DPTopToolBar"
const UserPassword = props => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>User Password</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumbs title="My Utilities" breadcrumbItem="User Password" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <DPTopToolBar
                    //Help Button
                    helpEnable={true}
                    helpClick={() => {
                      alert("Help")
                    }}
                    //Favorite Button
                    favoriteEnable={true}
                    favoriteClick={() => {
                      alert("Favorite")
                    }}
                    //New Button
                    newEnable={true}
                    newClick={() => {
                      alert("New")
                    }}
                    //Save Button
                    saveEnable={true}
                    saveClick={() => {
                      alert("Save")
                    }}
                    //ProcessButton
                    processEnable={true}
                    processClick={() => {
                      alert("Process")
                    }}
                    //Edit Button
                    editEnable={true}
                    editClick={() => {
                      alert("Edit")
                    }}
                    //Print Button
                    printEnable={true}
                    printClick={() => {
                      alert("Print")
                    }}
                    //Delete Button
                    deleteEnable={true}
                    deleteClick={() => {
                      alert("Delete")
                    }}
                    //Exit Button
                    exitEnable={false}
                    exitClick={() => {
                      alert("Exit")
                    }}
                  />
                  <Row>
                      <p></p>
                      <Col sm={12} md={6} className="mb-4-sm">
                  <DPTextBox
                          rowClass="mb-4-sm"
                          labelText="User ID"
                          textType="number"
                          maxLength="20"
                        />
                        <DPTextBox
                          rowClass="mb-4-sm"
                          labelText="Old Password"
                          textType="password"
                          maxLength="20"  
                          placeholder="password"
                        />
                        <DPTextBox
                          rowClass="mb-4-sm"
                          labelText="New Password"
                          textType="password"
                          maxLength="20"
                        />
                        <DPTextBox
                          rowClass="mb-4-sm"
                          labelText="Re-Type Password"
                          textType="password"
                          maxLength="20"
                        />
                        </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
export default UserPassword
